<template>
   <div class="s-dialog" v-if="visible">
     <div class="s-dialog-content">
       <div class="s-dialog-hd">
         <img src="../../assets/images/login_dialog_hd.png" alt="" class="dialog-hd-img">
       </div>
       <div class="s-dialog-bd">
         <div class="form-ctroller">
            <label>手机号</label>
           <input type="text" v-model="info.name">
         </div>
         <div class="form-ctroller">
            <label>密码</label>
           <input type="password" v-model="info.password">
         </div>
       </div>
       <div class="s-dialog-ft">
           <button class="s-button s-button-primary s-button-block"
             @click="login">登录</button>
          <div>
            <router-link :to="{name:'infoAdd'}" class="register-link">注册</router-link>
          </div>
       </div>
     </div>
   </div>
</template>

<script>
import config from '@/utils/config'
import auth from '@/utils/auth'
export default {
  name: 'loginDialog',
  props: {
    visible: {
      type: Boolean
    }
  },
  data () {
    return {
      info:{}
    }
  },
  methods: {
    login() {
      this.$http.post(`${config.HOST}douyin/v1/user/login`, this.info).then(
        response => {
          let data = response.body
          if (data.code === 0) {
            auth.setToken(data.data.token)
            this.$emit('success')
          } else {
            this.$toast.show(data.errorMessage || '登录失败')
          }
        },
        response => {
          // error callback
        }
      )
    }
  }
}
</script>

<style scoped lang="less">
@import "../button/button.less";

.s-dialog {
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  &-content {
    width: 250px;
    background-color: #fff;
    position: absolute;
    top: 30%;
    left: 50%;
    margin-left: -125px;
    border-radius: 15px;
    padding: 15px;
    text-align: center;
  }
  &-hd {
    .dialog-hd-img {
      width: 231/2px;
      height: 177/2px;
      margin-top: -80px;
    }
  }
  &-bd {
    margin: 30px 0;
    font-size: 18px;
    color: #5d5e66;
  }
}
.set-index {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  color: #5d5e66;
  font-size: 12px;
  background: #face12;
  border: none;
  outline: none;
  z-index: 3;
}
.form-ctroller{
  label{
    font-size: 12px;
    color: #9f9ea0;
    display: block;
    text-align: left;
  }
  input{
    border:0;
    display: block;
    width: 100%;
    margin-bottom: 15px;
    padding: 8px 5px;
    border-bottom: 1px solid #D8D8D8;
    outline: none;
  }
}
.register-link{
  font-size: 14px;
  color: #FE2B55;
  margin-top:15px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/login-dialog/index.vue